var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgSvgDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1960 1080",
    width: 1960,
    height: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1960,
    height: 1080,
    fill: "#001220"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "44.9%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#1565c0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#1565c0",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "44.9%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#1565c0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#00549e",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "44.9%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#00447c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#00549e",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "44.9%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#00447c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#00335b",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_4",
    x1: "44.9%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#00233c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#00335b",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_5",
    x1: "44.9%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#00233c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "55.1%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#1565c0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#1565c0",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "55.1%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#00549e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#1565c0",
    stopOpacity: 1
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "55.1%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#00549e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#00447c",
    stopOpacity: 1
  })))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "0%",
    x2: "55.1%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#00335b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#00447c",
    stopOpacity: 1
  })))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_4",
    x1: "0%",
    y1: "0%",
    x2: "55.1%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#00335b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#00233c",
    stopOpacity: 1
  })))), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_5",
    x1: "0%",
    y1: "0%",
    x2: "55.1%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.703703703703702%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2962962962963%",
    stopColor: "#00233c",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1960, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 594C-58.7 501.3 -117.5 408.6 -214 370.7C-310.5 332.7 -444.8 349.6 -514.4 297C-584 244.4 -589 122.2 -594 0L0 0Z",
    fill: "#011b2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 495C-49 417.7 -97.9 340.5 -178.3 308.9C-258.8 277.3 -370.7 291.4 -428.7 247.5C-486.7 203.6 -490.9 101.8 -495 0L0 0Z",
    fill: "#002b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 396C-39.2 334.2 -78.3 272.4 -142.7 247.1C-207 221.8 -296.5 233.1 -342.9 198C-389.4 162.9 -392.7 81.5 -396 0L0 0Z",
    fill: "#003b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 297C-29.4 250.6 -58.7 204.3 -107 185.3C-155.3 166.4 -222.4 174.8 -257.2 148.5C-292 122.2 -294.5 61.1 -297 0L0 0Z",
    fill: "#004c8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 198C-19.6 167.1 -39.2 136.2 -71.3 123.6C-103.5 110.9 -148.3 116.5 -171.5 99C-194.7 81.5 -196.3 40.7 -198 0L0 0Z",
    fill: "#005daf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 99C-9.8 83.5 -19.6 68.1 -35.7 61.8C-51.8 55.5 -74.1 58.3 -85.7 49.5C-97.3 40.7 -98.2 20.4 -99 0L0 0Z",
    fill: "#1565c0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 1080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -594C119.9 -587.7 239.7 -581.4 297 -514.4C354.3 -447.5 348.9 -319.8 388 -224C427 -128.2 510.5 -64.1 594 0L0 0Z",
    fill: "#011b2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -495C99.9 -489.7 199.8 -484.5 247.5 -428.7C295.2 -372.9 290.8 -266.5 323.3 -186.7C355.9 -106.8 425.4 -53.4 495 0L0 0Z",
    fill: "#002b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -396C79.9 -391.8 159.8 -387.6 198 -342.9C236.2 -298.3 232.6 -213.2 258.7 -149.3C284.7 -85.4 340.3 -42.7 396 0L0 0Z",
    fill: "#003b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -297C59.9 -293.8 119.9 -290.7 148.5 -257.2C177.1 -223.7 174.5 -159.9 194 -112C213.5 -64.1 255.3 -32 297 0L0 0Z",
    fill: "#004c8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -198C40 -195.9 79.9 -193.8 99 -171.5C118.1 -149.2 116.3 -106.6 129.3 -74.7C142.3 -42.7 170.2 -21.4 198 0L0 0Z",
    fill: "#005daf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -99C20 -97.9 40 -96.9 49.5 -85.7C59 -74.6 58.2 -53.3 64.7 -37.3C71.2 -21.4 85.1 -10.7 99 0L0 0Z",
    fill: "#1565c0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSvgDark);
export default __webpack_public_path__ + "static/media/bgSvgDark.809026a9a5806c1d6d22886523656a6f.svg";
export { ForwardRef as ReactComponent };